import React from "react";
import {
  IonItem,
  IonAvatar,
  IonImg,
  IonLabel,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonContent,
  IonChip,
  IonButton,
} from "@ionic/react";

import Section from "./Section";

export default function ShippingDetails({ title = "", options = [] }) {
  return (
    <Section title={title}>
      {options.map((option) =>
        option.isLink ? (
          <IonRow>
            <p className="section-content-p m-0">{option.label}&nbsp;·&nbsp;</p>

            <p className="section-content-p-sm-secondary m-0">{option.value}</p>
          </IonRow>
        ) : (
          <IonCol>
            <p className="section-content-p m-0">{option.label}</p>
            <IonRow>
              <p className="section-content-p-secondary m-0">{option.value}</p>
              {option.link && (
                <a className="section-link" style={{ marginLeft: "4px" }}>
                  {option.link}
                </a>
              )}
            </IonRow>
          </IonCol>
        )
      )}
      {/* <IonRow style={{ marginTop: "10px" }}>
        <a className="section-link">{moreInfo}</a>
      </IonRow> */}
    </Section>
  );
}
